import { AnyAction } from 'redux';
import { DashboardActions } from '../dashboard.actions';

export const showSofortschutzHinweistextReducer = function (
  sectionState: boolean = null,
  action: AnyAction,
): boolean {
  switch (action.type) {
    case DashboardActions.SHOW_SOFORTSCHUTZ_HINWEISTEXT: {
      return action.payload;
    }
    default:
      return sectionState;
  }
};
